export enum StepperButtonType {
  INCREMENT = 'increment',
  DECREMENT = 'decrement',
}

export const STEPPER_BUTTON_CONFIG = {
  [StepperButtonType.INCREMENT]: {
    icon: 'plus',
    iconWidth: 18,
    iconHeight: 18,
    backgroundColor: 'Button/Light/Primary',
    textColor: 'Label/Light/AlwaysLight Primary',
  },
  [StepperButtonType.DECREMENT]: {
    icon: 'minus',
    iconWidth: 16,
    iconHeight: 2,
    backgroundColor: 'Button/Light/Secondary',
    textColor: 'Button/Light/Primary',
  },
} as const;
